module.exports = __webpack_public_path__ + "a95f3f6e614a058bde23082002f373fb.MP3";